import { useTranslation } from 'react-i18next';

export const ShowcaseOtherSelections = ({
  isCandidateActivelySearching,
  candidateCurrentSelectionProcessesCount,
}) => {
  const { t } = useTranslation();

  const activelySearchingContent =
    candidateCurrentSelectionProcessesCount !== null
      ? t('showcase.otherSelections.inProgress', {
          count: candidateCurrentSelectionProcessesCount,
        })
      : t('showcase.otherSelections.notSpecified');

  const content = isCandidateActivelySearching
    ? activelySearchingContent
    : t('showcase.no');

  return (
    <td className="c-app-showcase__cell c-app-showcase__cell--center-aligned">
      <div className="c-app-showcase__motivation">
        <p className="c-app-showcase__motivation-text">{content}</p>
      </div>
    </td>
  );
};
